import {
    ORDERS,
    ORDERS_SHIPPED,
    CLAIMS,
    REPLENISHMENTS,
    ORDERS_PROCESSING,
    RETURNS,
    LOCATIONS,
    ROOT,
    GENERATE_LABELS,
    BILLING,
    WORK_ORDERS,
    NATURA_REPLENISHMENTS,
    SHIPPING_PACKAGES,
    LASTMILE_SHIPPING_METHODS,
    DISPATCH_SCHEDULES,
    CONFIGURATIONS,
    FULFILLMENT_ERRORS,
    AUTOMATED_COVERAGE_DEACTIVATIONS,
    WORKFORCE,
    INBOUND_APPOINTMENTS,
    C2C_RECEIVING,
    PENDING_PRINTS,
    ROMANEIOS,
} from "./constants";
import { hasAnyWorkforcePermission } from "../utils/workforceUtils";

export const navigation = [
    { id: 0, name: 'billing', href: BILLING, permission_key: 'create_billing_configuration', validate: true },
    { id: 1, name: 'dashboard', href: ROOT, permission_key: 'read_order_stats', validate: true },
    { id: 2, name: 'pending', href: ORDERS, permission_key: 'index_pending_orders', validate: true },
    { id: 3, name: 'pick_and_pack', href: ORDERS_PROCESSING, permission_key: 'index_processing_orders', validate: true },
    { id: 4, name: 'shipments', href: ORDERS_SHIPPED, permission_key: 'index_shipped_orders', validate: true },
    { id: 5, name: 'generate_labels', href: GENERATE_LABELS, permission_key: 'generate_labels_only', validate: false },
    { id: 6, name: 'returns', href: RETURNS, permission_key: 'create_and_recieve_returns', validate: true },
    { id: 7, name: 'inventory', href: LOCATIONS, permission_key: 'index_inventory', validate: true },
    { id: 8, name: 'load', href: REPLENISHMENTS, permission_key: 'index_replenishments', validate: true },
    { id: 9, name: 'claims', href: CLAIMS, permission_key: 'index_claims', validate: true },
    { id: 10, name: 'maquilas', href: WORK_ORDERS, permission_key: 'index_work_orders', validate: true },
    { id: 12, name: 'natura_replenishments', href: NATURA_REPLENISHMENTS, permission_key: 'natura_inbound_management' },
    { id: 13, name: 'lastmile_shipping_methods', href: LASTMILE_SHIPPING_METHODS, permission_key: 'index_shipping_methods_management', validate: true },
    { id: 14, name: 'dispatch_schedules', href: DISPATCH_SCHEDULES, permission_key: 'index_dispatch_schedules', validate: true },
    { id: 15, name: 'configurations', href: CONFIGURATIONS, permission_key: null, validate: true },
    { id: 21, name: 'fulfillment_errors', href: FULFILLMENT_ERRORS, permission_key: 'index_processing_orders', validate: true },
    { id: 16, name: 'automated_coverage_deactivations', href: AUTOMATED_COVERAGE_DEACTIVATIONS, permission_key: 'manage_automated_shipping_coverage_deactivations', validate: true },
    { id: 18, name: 'workforce', href: WORKFORCE, permission_key: null, validate: true, isVisible: hasAnyWorkforcePermission },
    { id: 19, name: 'inbound_appointments', href: INBOUND_APPOINTMENTS, permission_key: 'complete_replenishment', validate: true },
    { id: 20, name: 'cubbitos', href: C2C_RECEIVING, permission_key: 'c2c_receiving_read', validate: true },
    { id: 22, name: 'pending_prints', href: PENDING_PRINTS, permission_key: null, validate: true },
    { id: 23, name: 'romaneios', href: ROMANEIOS, permission_key: 'index_shipping_dispatches', validate: true },
];

export const userHasPermission = (user, permission_key) => {
    if (permission_key) {
        if ((user.permissions && (permission_key in user.permissions) && user.permissions[permission_key])) {
            return true
        }
        else {
            return false
        }
    }
    return true
}
